import PropTypes from 'prop-types';

const questionLinkPropType = PropTypes.shape({
    id: PropTypes.number,
    enabled: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    read_tag: PropTypes.string,
    write_tag: PropTypes.string,
    patient_table_id: PropTypes.number,
});

export default questionLinkPropType;
